import React from 'react';
import type { ReactNode } from 'react';
interface SectionTitleProps {
  children: ReactNode;
  id?: string;
  className?: string;
}
export function SectionTitle({
  children,
  id,
  className = ''
}: SectionTitleProps) {
  return <h2 id={id} className={`text-balance font-display text-[2.6rem] font-bold uppercase leading-[0.95] tracking-[-0.005em] sm:text-[3.25rem] lg:text-[3.9rem] ${className}`} data-id="element-367" data-mp="rkx9utr568u9">
      {children}
    </h2>;
}